import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value", "disabled", "aria-invalid"]
const _hoisted_3 = {
  key: 0,
  value: "",
  disabled: ""
}
const _hoisted_4 = ["value"]

import { computed, ref, useAttrs, useId } from "vue";
import { openNativeSelect } from "@shared/Components/Dropdown/open-native-select";
import type { DropdownEmits, DropdownProps, NormalizedOption } from "@shared/Components/Dropdown/Dropdown.types";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'Dropdown',
  props: {
    id: {},
    title: {},
    options: {},
    keyvalueoptions: {},
    defaultValue: {},
    dropdownModifier: {},
    selectModifier: {},
    selectedValue: {},
    modelValue: {},
    disabled: { type: Boolean },
    readOnly: { type: Boolean },
    isInvalid: { type: Boolean }
  },
  emits: ["update:modelValue", "onSelect"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const attrs = useAttrs();
const generatedId = useId();
const selectElement = ref<HTMLSelectElement | null>(null);
const pointerInteraction = ref(false);

const normalizedOptions = computed<NormalizedOption[]>(() => {
  const keyValueOptions = props.keyvalueoptions ?? [];
  if (keyValueOptions.length > 0) {
    return keyValueOptions.map((option) => ({
      label: option.key,
      value: option.value,
    }));
  }

  return (props.options ?? []).map((option) => ({
    label: option,
    value: option,
  }));
});

const currentValue = computed(() => props.modelValue ?? props.selectedValue ?? "");
const selectId = computed(() => props.id || generatedId);
const selectAttrs = computed(() => {
  const { class: _class, style: _style, ...rest } = attrs;
  return rest;
});

function selectOption(value: string): void {
  if (props.disabled || props.readOnly) {
    return;
  }

  emit("update:modelValue", value);
  emit("onSelect", value);
}

function handleChange(event: Event): void {
  selectOption((event.target as HTMLSelectElement).value);
}

function handleFieldPointerDown(): void {
  pointerInteraction.value = true;
}

function handleFieldClick(event: MouseEvent): void {
  if (event.target instanceof HTMLSelectElement) {
    return;
  }

  openSelect();
}

function handleFieldFocusOut(): void {
  pointerInteraction.value = false;
}

function handleFieldKeyDown(): void {
  pointerInteraction.value = false;
}

function openSelect(): void {
  if (props.disabled || props.readOnly) {
    return;
  }

  const select = selectElement.value;
  if (!select) {
    return;
  }

  openNativeSelect(select);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$attrs.class, __props.dropdownModifier, 'wrapper-dropdown']),
    style: _normalizeStyle(_ctx.$attrs.style)
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: selectId.value,
          class: "wrapper-dropdown__label label"
        }, _toDisplayString(__props.title), 9 /* TEXT, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'wrapper-dropdown__field',
        { 'wrapper-dropdown__field--invalid': __props.isInvalid },
        { 'wrapper-dropdown__field--read-only': __props.readOnly },
        { 'wrapper-dropdown__field--disabled': __props.disabled },
        { 'wrapper-dropdown__field--pointer-interaction': pointerInteraction.value },
      ]),
      onFocusout: handleFieldFocusOut,
      onKeydown: handleFieldKeyDown,
      onPointerdown: handleFieldPointerDown,
      onClick: handleFieldClick
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("select", _mergeProps({
        id: selectId.value,
        ref_key: "selectElement",
        ref: selectElement
      }, selectAttrs.value, {
        value: currentValue.value,
        disabled: __props.disabled || __props.readOnly,
        "aria-invalid": __props.isInvalid || undefined,
        class: ['wrapper-dropdown__select', __props.selectModifier],
        onChange: handleChange
      }), [
        (__props.defaultValue)
          ? (_openBlock(), _createElementBlock("option", _hoisted_3, _toDisplayString(__props.defaultValue), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalizedOptions.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value
          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ], 16 /* FULL_PROPS */, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "wrapper-dropdown__icon icon icon--arrow-down",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */))
    ], 34 /* CLASS, NEED_HYDRATION */)
  ], 6 /* CLASS, STYLE */))
}
}

})